import { Component, Input } from '@angular/core';

@Component({
    selector: 'loader-component',
    standalone: true,
    template: `
    <div class="loader-wrapper" [class.overlay]="overlay">
      <div class="spinner"></div>
    </div>
  `,
    styleUrls: ['./loader.component.css']
})
export class LoaderComponent
{
    @Input() overlay = false;
}
